import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import { Button, Col, Label, Row } from 'reactstrap';
import { faAngleLeft, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components 
import MainCard from '../../../../../components/MainCard'
import TextField from '../../../../../components/TextField';

//Helpers
import { validarCampos, objCampo } from "../../../../../helpers/ValidadorDeCampos";
import { showMessage } from "../../../../../helpers/message";

//API
import regional_api from '../../../../../api/regional_api';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateRegional() {
  return {
    identificacao: "",
    status: "Ativo",
    geojson: null,
    tipo: "Bairros",
    bairros: []
  }
}

export default function CadastroRegional({ id = null, handleVoltar }) {
  //State para editar ou cadastrar regional
  const [regional, setRegional] = useState(initialStateRegional());

  //Estado de controle do centro do geojson
  const [centerGeoJson, setCenterGeoJson] = useState(null);

  //Estado de referencia do mapa
  const [map, setMap] = useState(null);

  //State para pegar erros
  const [errors, setErrors] = useState({});

  const { setLoading, loading } = useAuth();

  const loadRegionalItem = (id) => {
    if (id != null) {
      setLoading(true);
      regional_api.getItem(id).then(response => {
        if (!!response.data.geojson) {
          response.data.geojson = JSON.parse(response.data.geojson);
          setCenterGeoJson([response.data.geojson.geometry.coordinates[0][0][1], response.data.geojson.geometry.coordinates[0][0][0]]);
          response.data.tipo = "GeoJson";
        } else {
          response.data.tipo = "Bairros";
        }
        setRegional(response.data);
      }).catch(error => {
        showMessage("Aviso", error.message, "error", null);
      }).finally(() => setLoading(false));
    }
  }

  useEffect(() => {
    loadRegionalItem(id);
  }, []);


  //Estado de controle dos campos obrigatorios 
  const [campos, setCampos] = useState([
    objCampo({ name: "identificacao", required: true }),
    objCampo({ name: "status", required: true }),
    objCampo({ name: "tipo", required: true }),
  ]);

  //Opções do campo de status
  const optionsStatus = [
    { label: "Ativo", value: "Ativo" },
    { label: "Inativo", value: "Inativo" },
  ]
  //Opções do campo de tipo
  const optionsTipo = [
    { label: "Bairros", value: "Bairros" },
    { label: "GeoJson", value: "GeoJson" },
  ]


  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    //Verificar se um arquivo foi selecionado
    if (!file) {
      showMessage("Aviso", "Por favor, selecione um arquivo.", "error", null);
      return;
    }

    //Verifica a extensão do arquivo
    const validExtension = '.geojson';
    const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

    if (fileExtension !== validExtension) {
      showMessage("Aviso", "Por favor, selecione um arquivo GeoJSON.", "error", null);
      //Limpa o campo de seleção de arquivo
      event.target.value = null;
      return;
    }
    setLoading(true);
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      if (content) {
        const _content = JSON.parse(content);
        if (_content.geometry && _content.geometry.coordinates && _content.geometry.coordinates.length > 0 && _content.geometry.coordinates[0].length > 0) {
          setCenterGeoJson([_content.geometry.coordinates[0][0][1], _content.geometry.coordinates[0][0][0]]);
          if (map && regional.geojson)
            map.flyTo([_content.geometry.coordinates[0][0][1], _content.geometry.coordinates[0][0][0]]);
        }
        setRegional({
          ...regional,
          geojson: _content
        });
      }
      setLoading(false);
    };
    reader.readAsText(file);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setRegional({
      ...regional,
      [name]: value
    })
  }

  //Função de controle do onChange do campo de tipo
  const onChangeTipo = (e) => {
    const { name, value } = e.target;
    const _regional = {
      ...regional,
      [name]: value
    };
    if (value == "Bairros") {
      _regional.geojson = "";
      setCenterGeoJson(null);
    } else if (value == "GeoJson") {
      _regional.bairros = [];
    }
    setRegional(_regional);
  }

  //onChange para os documentos
  const onChangeBairros = (inputValue) => {
    setRegional({
      ...regional,
      bairros: typeof inputValue === "object" ?
        [...regional.bairros.filter(opcao => inputValue.some(value => value.value == opcao))] :
        [...regional.bairros, inputValue]
    });
  }

  const handleSubmitRegional = () => {
    const _errors = validarCampos(regional, campos);

    //Checando se os bairros ou o geojson foram preenchidos
    if (regional.tipo == "Bairros" && regional.bairros.length == 0) {
      _errors[1].push(objCampo({ name: "bairros", required: true }));
      _errors[0].bairros = { message: "" };

    } else if (regional.tipo == "GeoJson" && regional.geojson == "") {
      _errors[1].push(objCampo({ name: "geojson", required: true }));
      _errors[0].geojson = { message: "" };
    }

    setErrors(_errors[0]);
    if (_errors[1].length > 0)
      return;

    const _regional = { ...regional }
    if (!!_regional.geojson)
      _regional.geojson = JSON.stringify(_regional.geojson);

    if (_regional.id) {
      setLoading(true);
      regional_api.put(_regional).then(response => {
        showMessage("Aviso", "Regional atualizada com sucesso.", "success", handleVoltar);
      })
        .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
        .finally(() => setLoading(false));
    } else {
      setLoading(true);
      regional_api.post(_regional).then(response => {
        showMessage("Aviso", "Regional criada com sucesso.", "success", handleVoltar);
      })
        .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
        .finally(() => setLoading(false));
    }
  }

  return (
    <>
      <Button onClick={() => {
        handleVoltar()
        setRegional(initialStateRegional())
      }} className='px-4'>
        <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
        Voltar
      </Button>
      <MainCard>
        <h5 style={{ color: "#666" }}>Cadastro de Regional</h5>
        <Row>
          <Col md={"4"} lg={4}>
            <TextField
              name={"identificacao"}
              label={"* Descrição"}
              value={regional.identificacao}
              onChange={onChange}
              invalid={!!errors.identificacao}
            />
          </Col>
          <Col md="12" lg="4">
            <TextField label={"* Status"}
              type={"select"}
              onChange={onChange}
              options={optionsStatus}
              value={regional.status}
              name={"status"}
            />
          </Col>
          <Col md="12" lg="4">
            <TextField
              label={"* Tipo"}
              type={"select"}
              onChange={onChangeTipo}
              options={optionsTipo}
              value={regional.tipo}
              name={"tipo"}
            />
          </Col>
          {
            regional.tipo == "Bairros" &&
            <Col md="12" lg="12" className='mt-2'>
              <TextField
                invalid={!!errors.bairros}
                label={"* Bairros"}
                type="select"
                creatable
                name={"bairros"}
                onChange={onChangeBairros}
                value={regional.bairros.map(value => {
                  return { value: value, label: value };
                })}
              />
            </Col>
          }
          {
            regional.tipo == "GeoJson" &&
            <Col md={12} lg={12}>
              <TextField
                name={"geojson"}
                label={"* Importar GEOJSON"}
                type={"file"}
                options={[{ value: "Ativo", label: "Ativo" }, { value: "Inativo", label: "Inativo" }]}
                onChange={handleFileUpload}
                invalid={!!errors.geojson}
              />
            </Col>
          }
        </Row>
        {regional.geojson && centerGeoJson != null && (
          <Row >
            <Col md={12} lg={12} >
              <Label>Mapa</Label>
              <div className='rounded overflow-hidden'>
                <MapContainer whenCreated={setMap} style={{ height: "400px" }} center={centerGeoJson} zoom={11}>
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  {!loading && <GeoJSON data={regional.geojson} />}
                </MapContainer>
              </div>
            </Col>
          </Row>
        )}
        <Row className='d-flex justify-content-center mt-3'>
          <Button
            color={regional.id ? 'warning text-white' : 'success'}
            style={{ width: 160 }}
            onClick={handleSubmitRegional}
          >
            {regional.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
          </Button>
        </Row>
      </MainCard>
    </>
  );
}